const en: Record<string, string> = {
  'features.todo.empty': 'No tasks yet. Add one below.',
  'features.todo.add': 'Add',
  'features.todo.addPlaceholder': 'New task...',
  'features.todo.noNote': 'No notes yet.',
  'features.todo.showArchived': 'Show {{count}} archived item(s)',
  'features.todo.hideArchived': 'Hide archived items',
  'features.todo.dueDate': 'Due date',
  'features.todo.configure': 'Labels',
  'features.todo.doneConfiguring': 'Done configuring',

  'features.kanban.empty': 'No cards yet.',
  'features.kanban.addCard': 'Add',
  'features.kanban.addCardPlaceholder': 'Card title...',
  'features.kanban.addColumn': 'Add column',
  'features.kanban.column': 'Column',
  'features.kanban.addColumnPlaceholder': 'Column name...',
  'features.kanban.noDocument': 'No notes yet.',
  'features.kanban.deleteColumn': 'Delete column',
  'features.kanban.maxColumns': 'Maximum 4 columns reached.',
  'features.kanban.notes': 'Notes',
  'features.kanban.archiveCardTitle': 'Archive this card?',
  'features.kanban.archiveCardMessage':
    'Archive "{{title}}"? It will no longer appear on the board.',
  'features.kanban.deleteColumnMessage':
    'Delete column "{{name}}"? All cards in this column will be lost.',
  'features.kanban.configureColumns': 'Columns',
  'features.kanban.saveColumns': 'Save column layout',
  'features.kanban.clickToRename': 'Click to rename',
  'features.kanban.showArchived': 'Show archived',
  'features.kanban.hideArchived': 'Hide archived',
  'features.kanban.restore': 'Restore',
  'features.kanban.archived': 'Archived',
  'features.kanban.moveToTop': 'Move to top',
  'features.kanban.moveToBottom': 'Move to bottom',
  'features.kanban.size': 'Story points',
  'features.kanban.setSize': 'Set story points',
  'features.kanban.filterBy': 'Filter:',
  'features.kanban.filterAll': 'All',
  'features.kanban.manageLabels': 'Labels',
  'features.kanban.noLabels': 'No labels yet.',
  'features.kanban.addLabel': 'Add',
  'features.kanban.newLabelPlaceholder': 'Label name...',
  'features.kanban.assignee': 'Assignee',
  'features.kanban.noAssignee': 'No assignee',
  'features.kanban.dueDate': 'Due date',
  'features.kanban.hideContent': 'Hide content',
  'features.kanban.showContent': 'Show content',
  'features.tasks.openInPopup': 'Open in full view',
  'features.tasks.reminders': 'Reminders',
  'features.tasks.addReminder': 'Add reminder',
  'features.tasks.reminderNotification': 'Push notification',
  'features.tasks.reminderMail': 'Email',

  'dashboard.tasks.empty': 'No upcoming tasks assigned to you.',
  'dashboard.tasks.openSource': 'Open in project',
  'dashboard.tasks.todoStatus': 'Todo',
  'dashboard.tasks.markDone': 'Mark as done',
  'dashboard.tasks.markDoneConfirm': 'Mark "{{title}}" as done?',
};

export default en;
